<template>
  <section class="special-gifts-trust-us">
    <v-container fluid class="px-0">
      <h2 class="special-gifts-trust-us__title text-center">нам доверяют</h2>

      <div class="special-gifts-trust-us__companies d-flex align-center">
        <div v-for="company in companies" class="special-gifts-trust-us__company">
          <v-img :src="company.ICON" :alt="company.NAME" contain :eager="true" @load.once="onImageLoad"></v-img>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
import { horizontalLoop } from '@/utils/gsap/horizontalLoop';
import gsap from 'gsap';

export default {
  name: 'special-gifts-trust-us',
  data() {
    return {
      oldWidth: null,
      timeout: null,
      loopEl: null,
      loopSpeed: 0.5,
      loadedCount: 0,
      isAllImagesLoaded: false,
    }
  },
  computed: {
    companies() {
      return this.$store.state.page.SpecialGiftsController.companies;
    },
    totalCompanies() {
      return this.companies.length;
    },
  },
  methods: {
    onImageLoad() {
      this.loadedCount++;
      if (this.loadedCount === this.totalCompanies) {
        this.isAllImagesLoaded = true;
        console.log('all images loaded');
      }
    },
    initAnimation() {
      this.destroyLoop();
      const companies = gsap.utils.toArray(".special-gifts-trust-us__company");

      if (!companies.length) return;

      gsap.set(companies, { clearProps: "x,xPercent" });
      this.loopEl = horizontalLoop(companies, {speed: this.loopSpeed, repeat: -1});
    },
    startLoop() {
      this.$nextTick(() => {
        this.initAnimation();
      });
    },
    destroyLoop() {
      if (this.loopEl) {
        this.loopEl.kill();
        this.loopEl = null;
      }
    },
    onResize() {
      const currentWidth = window.innerWidth;
      if(this.oldWidth === currentWidth) return;
      
      this.oldWidth = currentWidth;

      clearTimeout(this.timeout);
      
      this.timeout = setTimeout(() => {
        if (this.isAllImagesLoaded) this.startLoop();
      }, 150);
    }
  },
  watch: {
    isAllImagesLoaded(isLoaded) {
      if (isLoaded) {
        this.startLoop();
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    this.destroyLoop();
  }
}
</script>

<style lang="scss">
.special-gifts-trust-us {
  margin-bottom: 24px;
  
  @include up($md) {
    margin-bottom: 53px;
  }

  & > .container {
    padding-top: 24px;
    padding-bottom: 24px;

    @include up($md) {
      padding-top: 53px;
      padding-bottom: 53px;
    }
  }

  &__title {
    margin-bottom: 32px;
    
    @include up($md) {
      margin-bottom: 64px;
    }
  }

  &__companies {
    overflow-x: hidden;
  }

  &__company {
    display: flex;
    padding: 0 16px;
    flex: 0 0 auto;
    max-width: 250px;
    
    @include up($md) {
      padding: 0 22px;
      max-width: 350px;
    }

    .v-image {
      width: 100%;
      height: 100%;
    }
  }
}
</style>